
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5SbPw", function(module, exports) {
module.exports = JSON.parse('{"dismissButton":"OK","jira-issueview-status.issue-view-resolution-changeboarding-body":"Damit wichtige Informationen an einer Stelle aufbewahrt werden, haben wir das Status- und L\xf6sungsfeld nach links verschoben.","jira-issueview-status.issue-view-resolution-changeboarding-heading":"Der Status befindet sich jetzt auf der linken Seite","jira-issueview-status.issue-view-status-changeboarding-body":"Damit wichtige Informationen an einer Stelle aufbewahrt werden, haben wir den Status nach links verschoben.","jira-issueview-status.issue-view-status-changeboarding-heading":"Der Status befindet sich jetzt auf der linken Seite","post-office.jira-issueview-status.main-heading.no-translate":"Willkommen beim Status der Jira-Vorgangsansicht"}');

});


//# sourceMappingURL=de.0926f5e1.js.map
